import React, { useEffect, useState } from "react";
import { get } from '@aws-amplify/api';
import AppLayout from './components/AppLayout';


const EconomicEvents = ({ signOut, icType }) => {
  console.log("EconomicEvents : icType = " + icType);

  const [displayMessage, setDisplayMessage] = useState('');
  const [economicImpacts, setEconomicImpacts] = useState([]);
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  


  useEffect(() => {
    console.log("Executing useEffect");
    callEconomicEvents();
  }, []);

  async function callEconomicEvents() {
    try {
      setDisplayMessage("Loading Economic Events ...");
      const data = await getEconomicEvents();
      //setEconomicImpacts(data); // Store the fetched data in state
      console.log("getEconomicEvents : completed");
      setDisplayMessage("");
    } catch (error) {
      console.error("Error fetching economic events:", error);
    }
  }

  async function getEconomicEvents() {
    try {
      const myAPI = "mktappapi";
      const response = await get({
        apiName: myAPI,
        path: '/getEconomicEvents',
        options: {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      }).response;
      let resp = await response.body.json();
      await Promise.resolve(resp)
        .then(async () =>{
          await console.log("getEconomicEvents : resp = ",resp);
          
          // Sort by timestamp in ascending order
          resp.sort((a, b) => a.timestamp - b.timestamp);
          
          setEconomicImpacts(resp);
      });
  
      // Check if response has a data object and await it if needed
      const responseData = await response.response;
      console.log("API Response:", responseData);
  
      return responseData ? responseData : []; // Ensure it returns an array
    } catch (error) {
      console.error("Error fetching economic events:", error);
      return [];
    }
  }

  return (
    <AppLayout signOut={signOut}>
      <EconomicImpactsTable economicImpacts={economicImpacts} displayMessage={displayMessage} />
    </AppLayout>
  );
};

const EconomicImpactsTable = ({ economicImpacts, displayMessage }) => {
  const processedData = economicImpacts.map((item) => ({
    ...item,
    date: item.date.split(" ")[0], // Extract only the date
    description: decodeHtmlEntities(item.description),
  }));

  return (
    <div style={{ padding: '24px', maxWidth: '1400px', margin: '0 auto' }}>
      {/* Page Title */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)', marginBottom: '8px' }}>
          Economic Events Calendar
        </h1>
        <p style={{ fontSize: '14px', color: 'rgba(107, 114, 128, 1)' }}>
          Upcoming economic reports and indicators
        </p>
      </div>

      {/* Loading Message */}
      {displayMessage && (
        <div style={{
          padding: '12px',
          marginBottom: '16px',
          background: 'rgba(59, 130, 246, 0.1)',
          borderRadius: '8px',
          color: '#3b82f6',
          fontWeight: '500'
        }}>
          {displayMessage}
        </div>
      )}

      {/* Table Container */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        border: '1px solid rgba(229, 231, 235, 1)',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
          }}>
            <thead>
              <tr style={{
                background: 'rgba(249, 250, 251, 1)',
                borderBottom: '2px solid rgba(229, 231, 235, 1)'
              }}>
                <th style={{
                  padding: '16px',
                  textAlign: 'left',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: 'rgba(55, 65, 81, 1)',
                  whiteSpace: 'nowrap'
                }}>
                  Date
                </th>
                <th style={{
                  padding: '16px',
                  textAlign: 'left',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: 'rgba(55, 65, 81, 1)',
                  whiteSpace: 'nowrap'
                }}>
                  Time
                </th>
                <th style={{
                  padding: '16px',
                  textAlign: 'left',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: 'rgba(55, 65, 81, 1)',
                  minWidth: '200px'
                }}>
                  Report
                </th>
                <th style={{
                  padding: '16px',
                  textAlign: 'left',
                  fontSize: '14px',
                  fontWeight: '600',
                  color: 'rgba(55, 65, 81, 1)',
                  minWidth: '300px'
                }}>
                  Description
                </th>
              </tr>
            </thead>
            <tbody>
              {processedData.length > 0 ? (
                processedData.map((item, index) => (
                  <tr
                    key={item.id}
                    style={{
                      borderBottom: '1px solid rgba(229, 231, 235, 1)',
                      transition: 'background-color 0.2s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = 'rgba(59, 130, 246, 0.05)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }}
                  >
                    <td style={{
                      padding: '16px',
                      fontSize: '14px',
                      color: 'rgba(17, 24, 39, 1)',
                      whiteSpace: 'nowrap',
                      fontWeight: '500'
                    }}>
                      {item.date}
                    </td>
                    <td style={{
                      padding: '16px',
                      fontSize: '14px',
                      color: 'rgba(55, 65, 81, 1)',
                      whiteSpace: 'nowrap'
                    }}>
                      {item.time}
                    </td>
                    <td style={{
                      padding: '16px',
                      fontSize: '14px',
                      color: 'rgba(17, 24, 39, 1)',
                      fontWeight: '500'
                    }}>
                      {item.report}
                    </td>
                    <td style={{
                      padding: '16px',
                      fontSize: '14px',
                      color: 'rgba(55, 65, 81, 1)',
                      lineHeight: '1.6'
                    }}
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    style={{
                      padding: '48px 16px',
                      textAlign: 'center',
                      fontSize: '14px',
                      color: 'rgba(107, 114, 128, 1)'
                    }}
                  >
                    No Economic Events Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

// Function to decode problematic characters
const decodeHtmlEntities = (str) => {
  if (!str) return "";
  return str
    .replace(/â€™/g, "’").replace(/â€œ/g, "“").replace(/â€�/g, "”")
    .replace(/â€“/g, "–").replace(/â€”/g, "—").replace(/â€¢/g, "•")
    .replace(/â€¦/g, "…").replace(/â‚¬/g, "€").replace(/â„—/g, "℗")
    .replace(/â©/g, "©").replace(/â®/g, "®").replace(/â„¢/g, "™")
    .replace(/Ã©/g, "é").replace(/Ã¨/g, "è").replace(/Ã¢/g, "â")
    .replace(/Ã¹/g, "ù").replace(/Ã§/g, "ç").replace(/Ãª/g, "ê")
    .replace(/Ã´/g, "ô").replace(/Ã¼/g, "ü").replace(/Ã¶/g, "ö")
    .replace(/Ã«/g, "ë").replace(/Ã¯/g, "ï").replace(/Ã¸/g, "ø")
    .replace(/Ã¥/g, "å").replace(/Ã±/g, "ñ")
    .replace(/&lt;br\/&gt;/gi, "<br/>"); // Handle <br> tags
};

export default EconomicEvents;